<ng-container *ngIf="data$ | async">
  <ng-container *ngIf="showLabel">
    <miq-record-detail-label [column]="config" #configLabel> </miq-record-detail-label>
  </ng-container>
  <mat-form-field appearance="outline">
    <mat-select
      hideSingleSelectionIndicator="true"
      [disabled]="config.isDisabled"
      [placeholder]="'shared.select' | xTranslate"
      [formControl]="control"
      (openedChange)="openedChange($event)"
    >
      <div class="ss-search-box-container">
        <input
          #searchInput
          [formControl]="optionsFilterControl"
          type="text"
          autocomplete="no-autofill"
          [placeholderLabel]="'shared.find' | xTranslate"
          class="ss-search-box-container-input"
        />
        <mat-icon
          *ngIf="optionsFilterControl?.value?.length > 0"
          class="ss-search-box-clear"
          (click)="clearSearchBox()"
        >
          close
        </mat-icon>
      </div>

      <!-- When searching and there are no matches-->
      <mat-option *ngIf="(filteredOptions | async)?.length === 0" disabled class="ss-no-matches">
        {{ 'shared.noMatchFound' | xTranslate }}
      </mat-option>

      <mat-option *ngFor="let option of filteredOptions | async" [value]="option.key">
        {{ option.key }}
      </mat-option>
    </mat-select>
  </mat-form-field>
</ng-container>
